//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default class AdminEvents extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {};
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
	}

	componentWillUnmount() {
	}


	

	render() {
		
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>Mix365 Admin Events</Col>
			</Row>
		);
	}
}
